// a context with all files from the translations directory/plus sub-directories
// that can be required with a request endings with ".json"
const req = require.context('./translations', true, /\.json$/);
const exports = {};

req.keys().forEach(file => {
  // Extract lang and name from the path (./en/common.json)
  const [lang, langFile] = file
    .replace('./', '')
    .replace('.json', '')
    .split('/');

  const language = lang === 'root' ? 'en' : lang;

  if (language && langFile) {
    if (!exports[language]) {
      exports[language] = {};
    }

    const messages = req(file);
    exports[language] = {
      ...exports[language],
      ...Object.keys(messages).reduce((acc, key) => {
        acc[`${langFile}.${key}`] = messages[key];
        return acc;
      }, {})
    };
  }
});

export default exports;
